// ─── Monetary / pricing types ─────────────────────────────────────────────────
// Cross-cutting value objects used across product, cart, order and payment domains.

import { DocReference } from './doc-reference.models';

/** Monetary amount with currency code (e.g. EUR). */
export class Price {
  amt: number;
  cur: string;
  amtWithTax?: number;
}

/** Type of discount that can be applied to a cart item. */
export enum DiscountType {
  WALLET = 'wallet',
  COUPON = 'coupon',
}

/**
 * Full price breakdown attached to a cart/order. All amounts in `cur`.
 * `noTaxAmt = totalAmt / (1 + taxPct/100)` and `taxAmt = noTaxAmt * taxPct/100`.
 */

export interface FullPrice {
  cur: string; // currency
  taxPct: number; // tax percentage (from const!)
  noTaxAmt: number; // amount previous to tax  (totalAmt/(1+taxPct/100))
  taxAmt: number; // amount representing the tax (noTaxAmt * taxPct/100)
  totalAmt: number; // total amount (original sum from products, those include tax)
}

/** Discount applied to a cart/order. */
export interface Discount {
  type: DiscountType;
  amount: number;
  currency: string;
  refId: string; // reference to entity generating this discount, according to type (userId, couponId)
  transactionRef?: DocReference; // reference to transaction generated by this discount
}


